/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/median.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The value that is greater than half of all values and less than half of all values, also known as the 50% `PERCENTILE`.',
  examples: [
    'FROM employees\n| STATS MEDIAN(salary), PERCENTILE(salary, 50)',
    'FROM employees\n| STATS median_max_salary_change = MEDIAN(MV_MAX(salary_change))',
    'TS exp_histo_sample\n| WHERE instance == "instance-0"\n| STATS p50 = ROUND(MEDIAN(responseTime), 4)',
    'TS histogram_timeseries_index\n| WHERE instance == "instance-0"\n| STATS p50 = ROUND(MEDIAN(responseTime::tdigest), 2)',
  ],
  note: 'Like `PERCENTILE`, `MEDIAN` is usually approximate.',
  params: {
    number: 'Expression that outputs values to calculate the median of.',
  },
};

export default docs;
